import React, { Component } from 'react';
import { withStyles } from '@material-ui/core/styles';
import InputLabel from '@material-ui/core/InputLabel';
import MenuItem from '@material-ui/core/MenuItem';
import FormHelperText from '@material-ui/core/FormHelperText';
import FormControl from '@material-ui/core/FormControl';
import Select from '@material-ui/core/Select';
import moment from 'moment'

const styles = theme => ({
  formControl: {
    margin: theme.spacing(1),
    minWidth: 165,
    marginTop: 0,
    height: 0
  },
  selectEmpty: {
    marginTop: theme.spacing(2),
  },
});

class TimePicker extends Component {
    constructor(props) {
      super(props);
      this.state = {
        selectedDate: '',
        props: {
          name: props.name,
          defaultValue: props.defaultValue ? props.defaultValue : '',
          placeholder: props.placeholder,
          isDisabled: props.isDisabled ? props.isDisabled : false,
        }
      }
    }

    handleDateChangev2 = (e) => { 
      e.preventDefault();
      this.setState({ props: { ...this.state.props, defaultValue: e.target.value } }, function(){
        this.props.pushData(e);
      })
    }

    render() {
        const { classes } = this.props;
        return (
        <>
        <div>
        <FormControl required  variant="filled" className={classes.formControl}>
        <InputLabel>{ this.state.props.placeholder }</InputLabel>
          <Select
            name={ this.state.props.name }
            value={ this.state.props.defaultValue }
            onChange={ (data) => { this.handleDateChangev2(data) }}
            style={{ background: '#FFF', color: '#000', borderRadius: 0, border: !this.state.props.isDisabled ? '1px dotted #CCC' : 0, cursor: 'no-drop'}}
            disabled={ this.state.props.isDisabled } >
            <MenuItem value={'00:00 AM'}>00:00 AM</MenuItem>
            <MenuItem value={'00:30 AM'}>00:30 AM</MenuItem>
            <MenuItem value={'01:00 AM'}>01:00 AM</MenuItem>
            <MenuItem value={'01:30 AM'}>01:30 AM</MenuItem>
            <MenuItem value={'02:00 AM'}>02:00 AM</MenuItem>
            <MenuItem value={'02:30 AM'}>02:30 AM</MenuItem>
            <MenuItem value={'03:00 AM'}>03:00 AM</MenuItem>
            <MenuItem value={'03:30 AM'}>03:30 AM</MenuItem>
            <MenuItem value={'04:00 AM'}>04:00 AM</MenuItem>
            <MenuItem value={'04:30 AM'}>04:30 AM</MenuItem>
            <MenuItem value={'05:00 AM'}>05:00 AM</MenuItem>
            <MenuItem value={'05:30 AM'}>05:30 AM</MenuItem>
            <MenuItem value={'06:00 AM'}>06:00 AM</MenuItem>
            <MenuItem value={'06:30 AM'}>06:30 AM</MenuItem>
            <MenuItem value={'07:00 AM'}>07:00 AM</MenuItem>
            <MenuItem value={'07:30 AM'}>07:30 AM</MenuItem>
            <MenuItem value={'08:00 AM'}>08:00 AM</MenuItem>
            <MenuItem value={'08:30 AM'}>08:30 AM</MenuItem>
            <MenuItem value={'09:00 AM'}>09:00 AM</MenuItem>
            <MenuItem value={'09:30 AM'}>09:30 AM</MenuItem>
            <MenuItem value={'10:00 AM'}>10:00 AM</MenuItem>
            <MenuItem value={'10:30 AM'}>10:30 AM</MenuItem>
            <MenuItem value={'11:00 AM'}>11:00 AM</MenuItem>
            <MenuItem value={'11:30 AM'}>11:30 AM</MenuItem>
            <MenuItem value={'12:00 PM'}>12:00 PM</MenuItem>
            <MenuItem value={'12:30 PM'}>12:30 PM</MenuItem>
            <MenuItem value={'13:00 PM'}>13:00 PM</MenuItem>
            <MenuItem value={'13:30 PM'}>13:30 PM</MenuItem>
            <MenuItem value={'14:00 PM'}>14:00 PM</MenuItem>
            <MenuItem value={'14:30 PM'}>14:30 PM</MenuItem>
            <MenuItem value={'15:00 PM'}>15:00 PM</MenuItem>
            <MenuItem value={'15:30 PM'}>15:30 PM</MenuItem>
            <MenuItem value={'16:00 PM'}>16:00 PM</MenuItem>
            <MenuItem value={'16:30 PM'}>16:30 PM</MenuItem>
            <MenuItem value={'17:00 PM'}>17:00 PM</MenuItem>
            <MenuItem value={'17:30 PM'}>17:30 PM</MenuItem>
            <MenuItem value={'18:00 PM'}>18:00 PM</MenuItem>
            <MenuItem value={'18:30 PM'}>18:30 PM</MenuItem>
            <MenuItem value={'19:00 PM'}>19:00 PM</MenuItem>
            <MenuItem value={'19:30 PM'}>19:30 PM</MenuItem>
            <MenuItem value={'20:00 PM'}>20:00 PM</MenuItem>
            <MenuItem value={'20:30 PM'}>20:30 PM</MenuItem>
            <MenuItem value={'21:00 PM'}>21:00 PM</MenuItem>
            <MenuItem value={'21:30 PM'}>21:30 PM</MenuItem>
            <MenuItem value={'22:00 PM'}>22:00 PM</MenuItem>
            <MenuItem value={'22:30 PM'}>22:30 PM</MenuItem>
            <MenuItem value={'23:00 PM'}>23:00 PM</MenuItem>
            <MenuItem value={'23:30 PM'}>23:30 PM</MenuItem>
          </Select>
        </FormControl>
        </div>
        </>
        );
    }
}

export default withStyles(styles, { withTheme: true })(TimePicker);